@if (viewMode() !== "kiosk") {
    <div class="header-wrapper">
        <div class="first-header-row">
            <div class="container first-header-row">
                <nav
                    class="d-flex d-lg-none menu"
                    style="cursor: pointer; align-self: center"
                    aria-label="Toggle Mobile Menu"
                >
                    <button
                        class="activeLink"
                        (click)="mobileMenuToggled.emit()"
                    >
                        <em
                            class="far fa-bars ps-1"
                            style="font-size: 28px"
                            aria-hidden="true"
                        ></em>
                    </button>
                </nav>
                <div class="locale-selection">
                    @if (!user()) {
                        <div routerLink="locale" style="cursor: pointer">
                            {{ params()?.country?.countryName }}
                        </div>
                    }
                    <div
                        class="userLogin d-flex align-items-center"
                        style="cursor: pointer"
                    >
                        <em
                            style="margin-right: 5px"
                            class="fa fa-user"
                            aria-hidden="true"
                        ></em>
                        @if (user()) {
                            <p
                                class="float-right"
                                (click)="userMenuToggled.emit()"
                                (keydown.enter)="userMenuToggled.emit()"
                            >
                                {{
                                    user().firstName
                                        ? user().firstName
                                        : ("profile" | translate)
                                }}
                            </p>
                        } @else {
                            <p appLoginButton class="float-right">
                                {{ "Login" | translate }}
                            </p>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="container second-header-row">
            <img
                class="logo"
                src="/assets/logo/Header_MyPoettinger.png"
                alt="MyPÖTTINGER"
                [routerLink]="['/home']"
            />
            <nav aria-label="Main Menu" class="d-none d-lg-flex menu">
                <poe-dropdown-menu
                    [routerLink]="['/machinesearch']"
                    [title]="'goToProducts' | translate"
                >
                </poe-dropdown-menu>
                @if (configuratorCountries.includes(params().country?.code)) {
                    <poe-dropdown-menu
                        [routerLink]="['/configurator']"
                        [title]="'configurator' | translate"
                        [badgeContent]="userConfigurations.value()?.length"
                    >
                    </poe-dropdown-menu>
                } @else {
                    <poe-dropdown-menu
                        [routerLink]="['/myMachines']"
                        [title]="'myMachines' | translate"
                        [badgeContent]="
                            userMachines.hasValue()
                                ? userMachines.value().length
                                : 0
                        "
                    >
                    </poe-dropdown-menu>
                }
                <poe-dropdown-menu [title]="'machineAdvisor' | translate">
                    <poe-menu-group [title]="'webbasedVersion' | translate">
                        <poe-menu-item
                            icon="assets/menu-icons/metering-wheel-assist.svg"
                            title="Metering Wheel Assist"
                            (click)="onClickPoetsem()"
                            (keydown.enter)="onClickPoetsem()"
                        ></poe-menu-item>
                        @if (params().country?.code?.split("_")[1] !== "US") {
                            <poe-menu-item
                                icon="assets/menu-icons/tramline-assist.svg"
                                title="Tramline Assist"
                                [routerLink]="['tramline-assist']"
                            >
                            </poe-menu-item>
                        }
                        <poe-menu-item
                            icon="assets/menu-icons/haytool-assist.svg"
                            title="Haytool Assist"
                            [routerLink]="['haytool-assist']"
                        ></poe-menu-item>
                        <poe-menu-item
                            layer="3"
                            icon="assets/menu-icons/row-crop-assist.svg"
                            title="Row Crop Assist"
                            [routerLink]="['row-crop-assist']"
                        ></poe-menu-item>
                    </poe-menu-group>
                    <poe-menu-group [title]="'mobileApps' | translate">
                        @for (appLink of appLinks(); track appLink) {
                            <poe-menu-item
                                [icon]="appLink.icon"
                                [title]="appLink.name"
                                (click)="openAppPopup(appLink)"
                                (keydown.enter)="openAppPopup(appLink)"
                            >
                            </poe-menu-item>
                        }
                    </poe-menu-group>
                </poe-dropdown-menu>
                <poe-dropdown-menu [title]="'help' | translate">
                    <poe-menu-item
                        [title]="'contact' | translate"
                        [routerLink]="['/contact']"
                    ></poe-menu-item>
                    <poe-menu-item
                        title="FAQs"
                        [routerLink]="['/faqs']"
                    ></poe-menu-item>
                </poe-dropdown-menu>
            </nav>
        </div>
    </div>
} @else {
    <div
        class="container d-flex"
        style="align-items: center; justify-content: space-between"
    >
        <img
            src="/assets/logo/Header_MyPoettinger.png"
            alt="MyPÖTTINGER"
            style="height: 25px; margin: 10px"
        />
        <div
            routerLink="locale"
            [queryParams]="{
                viewMode: viewMode(),
                returnUrl: 'configurator?viewMode=kiosk',
            }"
            class="locale-select"
        >
            DEMO
            <ion-icon name="globe-outline" size="default"></ion-icon>
            {{ params()?.country?.countryName }}
        </div>
    </div>
}
